var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"msg-dialog"},[_c('div',{staticClass:"msg-container",class:{active:_vm.msgStatus}},[_c('div',{staticClass:"msg-wrapper"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }